/**
 * @deprecated Use <Head> with <title> instead.
 */
export function changePageTitle(title, noAppend = false) {
  if (!title) {
    document.title = 'Fitness and Exercise Equipment Repair Parts';
  } else if (noAppend) {
    document.title = title;
  } else {
    document.title = title + ' | Fitness and Exercise Equipment Repair Parts';
  }
}